import React from 'react';
import TopBar from './components/layout/TopBar';
import Navbar from './components/layout/Navbar';
import Hero from './components/sections/Hero';
import StatsBar from './components/sections/StatsBar';
import Services from './components/sections/Services';
import HowItWorks from './components/sections/HowItWorks';
import WhyUs from './components/sections/WhyUs';
import Areas from './components/sections/Areas';
import Reviews from './components/sections/Reviews';
import CtaSection from './components/sections/CtaSection';
import Footer from './components/layout/Footer';
import MobileBar from './components/layout/MobileBar';

function App() {
  return (
    <div className="relative">
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <Services />
        <HowItWorks />
        <WhyUs />
        <Areas />
        <Reviews />
        <CtaSection />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}

export default App;